import { ACTION_TYPE } from '../../constants'
import { GtmBaseModel } from '../gtm-base.model/gtm-base.model'

export class GtmTakeAwardClickModel extends GtmBaseModel {
  constructor({ frequency }) {
    super()
    this.action_type = ACTION_TYPE.CLICK_TAKE_AWARD
    this.frequency = frequency
  }
}
